<template>
	<div class="pop_hours popup_wrap" style="display:block;">
		<div class="popup_in">
			<div class="popup">
				<div class="popup_close stay_close close-animate">
					<a href="javascript:void(0);" @click.prevent="$modal.hide('hours-modal')">
						<CLOSE />
					</a>
				</div>
				<h2 class="title25 center">בחר משלוח</h2>
				<div class="shipp_times" :class="{ error: error }">
					<div class="error_tx" v-if="error">עליך לבחור יום וטווח שעות למשלוח</div>
					<div class="shipp_times_scroll">
						<div
							class="shipp_time_row clearfix"
							v-for="(shippingTime, index) in shippingTimes"
							v-bind:key="shippingTime.date"
						>
							<h3 v-if="isNewWeek(index)" class="new_week_title">שבוע חדש:</h3>
							<div class="right shipp_time_col1">
								{{ shippingTime.day }}
								<span>{{ shippingTime.date }}</span>
							</div>
							<div class="right shipp_time_col2">
								<div
									class="right shipp_time_hour ease"
									v-for="shippingHour in shippingTime.hours"
									v-bind:class="{
										active:
											selectedHour.hourId == shippingHour.id &&
											selectedHour.slotIndex == shippingTime.date
									}"
									:key="shippingHour.id"
								>
									<a
										href="javascript:void(0);"
										@click="
											selectHour(shippingHour.id, shippingTime.date, shippingHour.employee_number)
										"
										>{{ shippingHour.hour }}</a
									>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="bt_green ease">
					<a href @click.prevent="confirmSelect">אישור</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import CLOSE from "../../assets/img/close.svg";
	import { mapGetters } from "vuex";
	export default {
		props: ["shippingTimes", "selected"],
		data() {
			return {
				selectedHour: false,
				error: false
			};
		},
		mounted() {
			if (this.orderEdit) {
				this.selectHour(String(this.selected.hourId), this.selected.slotIndex, this.selected.employee_number);
			}
		},
		computed: {
			...mapGetters(["orderEdit"]),
			currentDate() {
				return Date();
			}
		},
		methods: {
			selectHour(hourId, slot_index, employee_number) {
				this.selectedHour = {
					hourId: hourId,
					slotIndex: slot_index,
					employee_number: employee_number
				};
			},
			closePop() {
				this.$modal.hide("hours-model");
			},
			confirmSelect() {
				if (this.selectedHour) {
					this.$emit("Hour", this.selectedHour);
					this.$modal.hide("hours-modal");
				} else {
					this.error = true;
				}
			},
			isNewWeek(index) {
				if (!index) return false;
				let current_ship_item = this.shippingTimes[index];
				let prev_ship_item = this.shippingTimes[index - 1];

				let daybefore = prev_ship_item.day;
				let dayafter = current_ship_item.day;
				let daysArr = ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי"];
				if (daysArr.indexOf(daybefore) > daysArr.indexOf(dayafter)) {
					return true;
				}
				return false;
			}
		},
		components: {
			CLOSE
		}
	};
</script>

<style>
	.new_week_title {
		font-size: 19px;
		font-weight: 700;
		color: #f8bd39;
		margin-top: 15px;
		margin-bottom: 15px;
	}
</style>
